/**
 * Cue identifiers consumed by the active `AudioPlayer` (today: procedural
 * Web Audio synth). Add a cue here, then add a builder for it in
 * `synth-player.ts`. Native players will mirror this enum when wired in.
 */
export const SoundCue = {
  ButtonTap: 'button_tap',
  WordReveal: 'word_reveal',
  AcknowledgeWord: 'acknowledge_word',
  OpenVote: 'open_vote',
  VoteCast: 'vote_cast',
  PlayerEliminated: 'player_eliminated',
  RoundResult: 'round_result',
  GameWonFlic: 'game_won_flic',
  GameWonInfiltre: 'game_won_infiltre',
  GameWonClochard: 'game_won_clochard',
  ClockTick: 'clock_tick',
  Error: 'error',
} as const;
export type SoundCue = (typeof SoundCue)[keyof typeof SoundCue];

export type PlayOptions = {
  /** Per-call volume override in [0, 1]. */
  volume?: number;
};

export interface AudioPlayer {
  /** Best-effort cue playback. Never throws. */
  play(cue: SoundCue, options?: PlayOptions): void;
}
